import { TagSeverityType } from "primereact/tag"

export const statusType: Record<string, { value: string, severity: TagSeverityType }> = {
  TODO: { value: "To Do", severity: "info" },
  IN_PROGRESS: { value: "In Progress", severity: "warning" },
  DONE: { value: "Done", severity: "success" },
  CANCELLED: { value: "Cancelled", severity: "danger" },
}

export const priorityType: Record<string, { value: string, severity: string, icon: string }> = {
  HIGHEST: { value: "Highest", severity: "red", icon: "pi pi-angle-double-up" },
  HIGH: { value: "High", severity: "red", icon: "pi pi-angle-up" },
  MEDIUM: { value: "Medium", severity: "orange", icon: "pi pi-bars" },
  LOW: { value: "Low", severity: "blue", icon: "pi pi-angle-down" },
  LOWEST: { value: "Lowest", severity: "blue", icon: "pi pi-angle-double-down" },
}